import { render } from "./KYCCard.vue?vue&type=template&id=32ed0ddc&scoped=true"
import script from "./KYCCard.vue?vue&type=script&lang=js"
export * from "./KYCCard.vue?vue&type=script&lang=js"

import "./KYCCard.vue?vue&type=style&index=0&id=32ed0ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ed0ddc"]])

export default __exports__